const queryTypes = {
  USERS: 'DAUMAUWAU',
  SESSIONS: 'SESSIONS',
};

export default queryTypes;
